import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const SendIds = async (submitUrl, ids, method) => {
    let path = submitUrl.charAt(0) === '/' ? submitUrl : `/${submitUrl}`;

    const url = process.env.REACT_APP_CMS_API_PATH + path;
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;
    console.log('url here', url);
    console.log('ids here', ids);
    console.log('method here', method);

    return await axios({
        url,
        method: method,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        data: { ids },
    });
};
